<template>
  <div class="cb-navigator h-full w-[250px]">
    <div class="cb-navigator__content h-full px-4 pb-4 pt-8 overflow-hidden">
      <div class="top pr-1">
        <div class="flex items-center justify-between">
          <div class="title">{{ t('canvasUI.canvasBuilder.navigator.navigation') }}</div>

          <CButton @click="handleModeToggle">
            <template #icon>
              <CIcon :icon="mode === 'list' ? 'image' : 'list'" size="18" />
            </template>
          </CButton>
        </div>
        <div class="mt-4">
          <CInput
            ref="searchRef"
            v-model:value="search"
            clearable
            :placeholder="t('canvasUI.canvasBuilder.navigator.search')"
            :theme-overrides="{ color: 'transparent', colorFocus: 'transparent' }"
            @keyup.enter="handleSearchEnter"
          />
        </div>
      </div>
      <NavigatorPresentation
        ref="navigatorPresentationRef"
        :is-fullscreen-navigator="isFullscreenNavigator"
        :mode="mode"
        :search="search"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocalStorage } from '@vueuse/core'

import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CInput from '@lib/components/CInput/CInput.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import NavigatorPresentation from './NavigatorPresentation.vue'

withDefaults(defineProps<{ isFullscreenNavigator?: boolean }>(), { isFullscreenNavigator: false })

const { t } = useI18n()
const themeVars = useThemeVars()
const search = ref('')
const navigatorPresentationRef = ref<typeof NavigatorPresentation | null>(null)
const searchRef = ref<typeof CInput | null>(null)

const TOC_MODE_STORAGE_KEY = 'canvas_builder_toc_mode_preference'

const mode = useLocalStorage<'list' | 'thumbnails'>(TOC_MODE_STORAGE_KEY, 'list', {
  deep: true,
  listenToStorageChanges: true,
})

function handleSearchEnter() {
  if (!navigatorPresentationRef.value) return
  navigatorPresentationRef.value.goToFirstResult()
}

function handleModeToggle() {
  mode.value = mode.value === 'list' ? 'thumbnails' : 'list'
}
</script>

<style lang="scss" scoped>
.cb-navigator {
  font-family: 'Roboto', sans-serif;
  background-color: v-bind('themeVars.primary6');
}

.title {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.4px;
}
</style>
